import { render, staticRenderFns } from "./SingleService.vue?vue&type=template&id=92578c0a&"
import script from "./SingleService.vue?vue&type=script&lang=js&"
export * from "./SingleService.vue?vue&type=script&lang=js&"
import style0 from "./SingleService.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports